import {Record} from 'immutable';

const Icon = Record({
  id: null,
  link: null,
  iconSetId: null,
  iconSet: null,
  name: '',
  unicodeChar: '',
  optimizedFor: '',
  prefix: '',
  cssName: '',
  cssClass: '',
  status: '',
});

export default Icon;



// WEBPACK FOOTER //
// ./app/javascript/records/Icon.js